import { useState } from 'react';

/**
 * Custom hook to manage the visibility of context communities in the Graph component.
 */
export default function useShowContext() {
  const [triggerSignal, setTriggerSignal] = useState(1);

  const sendTriggerSignal = () => {
    setTriggerSignal((prev) => prev * (-1));
  };

  return {
    triggerSignal,
    sendTriggerSignal,
  };
}